export default {"src":"/_next/static/media/donate.e9f72822.svg","height":70,"width":51};